import React from 'react';
import Sidebar from '@repo/shared/components/Sidebar';
import { usePolyAuth } from '@repo/shared/hooks/PolyAuthContext.js';

/**
 * Participants component for Zoom meetings.
 * Thin wrapper around the shared Sidebar component.
 */
function Participants() {
  const { meetingUUID } = usePolyAuth();

  return (
    <Sidebar
      platform="zoom"
      meetingId={btoa(meetingUUID)}
    />
  );
}

export default Participants;
